<template>
    <a-card class="general-settings-wrap">
        <h2>
            General Agenda Settings
            <div class="border"></div>
        </h2>
        <div class="form">
            <p>General agenda settings, allowing you to choose if agenda is public or not, as well as if passed agenda sessions are visible.</p>
            <div
                v-if="!isOpen" 
                class="closed"
            >
                <a-button 
                    type="primary" 
                    icon="edit"
                    class="button"
                    @click="isOpen=true"
                >
                    Edit Section
                </a-button>
            </div>
            <div
                v-if="isOpen" 
                class="opened"
            >
                <div class="input-wrap">
                    {{ $t("adminAgenda.agendaName") }}
                    <a-input 
                        v-model="agendaName"
                        :maxLength="agendaNameMaxLength"
                        ref="toFocus"
                        style="margin-top: 4px;"
                        placeholder="Type session name here"
                    />
                    <span class="remainingText">{{ agendaNameRemainingLettersCount }}</span>
                </div>
                <div class="toggles">
                    <div class="toggle-wrap">
                        <div>
                            <a-switch v-model="isAgendaPublic" />
                            <span>Agenda is public</span>
                        </div>
                        <div class="desc">
                            Enable/disable option for agenda to be public and fully visible to all users.
                        </div>
                    </div>
                    <div class="toggle-wrap">
                        <div>
                            <a-switch v-model="isPassedSessions" />
                            <span>Passed sessions visible</span>
                        </div>
                        <div class="desc">
                            Enable/disable option for passed sessions to be visible on agenda page.
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <a-button class="button cancel" @click="isOpen=false">
                        {{ $t("button.cancel") }}
                    </a-button>
                    <a-button class="button" @click="onSaveChanges">
                        {{ $t("profile.saveChanges") }}
                    </a-button>
                </div>
            </div>
        </div>
    </a-card>
</template>

<script>
import { mapActions } from 'vuex';
import api from '@/api';
import AdminMixin from '@/views/admin-pages/adminMixin.js';
export default {
    mixins: [
        AdminMixin,
    ],
    data () {
        return {
            agendaNameMaxLength: 65,
            agendaName: '',
            isAgendaPublic: false,
            isPassedSessions: false,
            isOpen: false,
        };
    },
    computed: {
        agendaNameRemainingLettersCount () {
            const remainingLettersCount = this.agendaNameMaxLength - this.agendaName.length;
            return `${remainingLettersCount} characters remaining. Maximum ${this.agendaNameMaxLength} characters.`
        },
    },
    created () {
        this.init();
    },
    methods: {
        ...mapActions(['updateFairConfig']),
        async init () {
            try {
                this.startLoading();
                const res = await api.getFairConfig();
                this.updateFairConfig(res.data.data);

                this.agendaName = res.data.data.FC_AGENDA_NAME;
                this.isAgendaPublic = Boolean(Number(res.data.data.FC_PUBLIC_AGENDA));
                this.isPassedSessions = Boolean(Number(res.data.data.FC_PASSED_AGENDA));
            } catch (error) {
                this.handleError(error);
            }
            this.stopLoading();
        },
        onSaveChanges () {
            this.saveConfig();
        },
        async saveConfig () {
            try {
                this.startLoading();
                await api.saveConfig({
                    data: {
                        FC_AGENDA_NAME: this.agendaName,
                        FC_PUBLIC_AGENDA: Number(this.isAgendaPublic),
                        FC_PASSED_AGENDA: Number(this.isPassedSessions),
                    },
                });
                this.showSuccessMessage('Changes saved');
            } catch (error) {
                this.handleError(error);
            }
            this.stopLoading();
        },
    },
};
</script>

<style lang="scss" scoped>
.general-settings-wrap {
    * {
        color: #001529;
        font-style: 'Roboto';
    }
    .button {
        display: flex;
        align-items: center;
        padding: 8px 16px;

        width: 141px;
        height: 40px;

        background: #2295D6;
        border-radius: 2px;
        color: #FFF;
        &.cancel {
            width: auto;
            justify-content: center;
            background: #FFF;
            color: #001529;  
        }
    }
    p {
        color: #001529;
        max-width: 876px;
    }
    h2 {
        position: relative;
        height: 50px;
        font-weight: 600;
        .border {
            $padding: 24px;
            background: #e8e8e8;
            height: 1px;
            width: calc(100% + #{$padding} * 2);
            left: calc(0px - #{$padding});
            position: absolute;
            bottom: 0;
        }
    }
    .form {
        .opened {
            .input-wrap {
                .remainingText {
                    display: inline-block;
                    margin:     8px 0 24px 0;
                }
            }
            .toggles {
                display: flex;
                margin: 20px 0 0 0;
                .toggle-wrap {
                    width: 370px;
                    display: flex;
                    flex-direction: column;
                    button {
                        margin-right: 27px;
                    }
                    .desc {
                        margin-top: 8px;
                    }
                }
            }
            .buttons {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 16px;
            }
        }
    }
}
</style>